import { useCallback } from 'react';
import { useMutateEntry } from '@utils/component-framework';

function useUpdateEntryLocationMutation(entryKey) {
  const mutater = useMutateEntry(entryKey);
  return useCallback(args => mutater(entry => {
    entry.data.currentPageId = args.pageId;
    return entry;
  }), [mutater]);
}

export { useUpdateEntryLocationMutation };
//# sourceMappingURL=location.update.js.map
